import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  CollectionEditPage,
  collectionProductsQueryOptions,
  collectionQueryOptions,
} from '@/features/collections';

export const Route = createFileRoute('/_authed/_active/s/$storeId/collections/$collectionId')({
  staticData: { tours: ['collections.editor'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, params }) => {
    const [row] = await Promise.all([
      context.queryClient.query({
        ...collectionQueryOptions(params.storeId, params.collectionId),
        staleTime: 'static',
      }),
      context.queryClient
        .query({
          ...collectionProductsQueryOptions(params.storeId, params.collectionId),
          staleTime: 'static',
        })
        .catch(() => undefined),
    ]);
    return { crumb: row.title };
  },
  component: CollectionEditPage,
});
